import React, { useMemo } from "react";
import { DefaultNavBarQuery } from "types/graphql-types";
import Links from "./Links";
import { isPresent } from "src/utils/checks";

type CruisesLaunchesLinksProps = {
  cruisesLaunches: DefaultNavBarQuery["cruisesLaunches"]["nodes"] | undefined;
  showItemsMedia?: boolean;
};
const CruisesLaunchesLinks: React.FC<CruisesLaunchesLinksProps> = ({
  cruisesLaunches
}) => {
  const links = useMemo(
    () =>
      (
        cruisesLaunches?.map((c) => {
          const href = c.page?.fullPath;
          const label = c.title?.localized;
          if (!href || !label) return undefined;

          return {
            _key: c.id!,
            href: href,
            label: label,
            trackingName: c.page?.metadata?.tracking?.name,

            // showItemsMedia ? c.page?.card?.image : undefined,
            image: undefined,

            content: c.description?.localized
          };
        }) || []
      )
        .filter(isPresent)
        .sort((a, b) => a.label.localeCompare(b.label)),
    []
  );

  return <Links links={links} />;
};

export default CruisesLaunchesLinks;
